<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="10">
                统计项目类型：
                <el-radio-group v-model="checkedClass" size="mini" @input="renderCharts">
                    <el-radio-button label="W">吴中区</el-radio-button>
                    <el-radio-button label="X">相城区</el-radio-button>
                    <el-radio-button label="G">高新区</el-radio-button>
                    <el-radio-button label="T">太湖区</el-radio-button>
                    <el-radio-button label="Y">园区</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="14">
                <el-alert type="warning" :closable="false" show-icon title="统计数据为最近5年数据"></el-alert>
            </el-col>
        </el-row>
        <el-divider><i class="el-icon-search"></i></el-divider>
        <div id="completeDiv" class="completeDiv" v-loading="divLoading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">

        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            checkedClass:"W",
            divLoading:false,
            myChart:null,
        }
    },
    mounted(){
        this.renderCharts()
    },
    methods:{
        async renderCharts(){
            // #region 参数
            var app = {};
            const posList = [
                'left',
                'right',
                'top',
                'bottom',
                'inside',
                'insideTop',
                'insideLeft',
                'insideRight',
                'insideBottom',
                'insideTopLeft',
                'insideTopRight',
                'insideBottomLeft',
                'insideBottomRight'
            ];
            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: posList.reduce(function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };
            app.config = {
                rotate: 0,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function () {
                    const labelOption = {
                        rotate: app.config.rotate,
                        align: app.config.align,
                        verticalAlign: app.config.verticalAlign,
                        position: app.config.position,
                        distance: app.config.distance,
                    };
                    this.myChart.setOption({
                        series: [
                            {
                                label: labelOption
                            },
                            {
                                label: labelOption
                            },
                            {
                                label: labelOption
                            },
                            {
                                label: labelOption
                            }
                        ]
                    });
                }
            };
            const labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: function (params) {
                    if (params.value > 0)
                        return params.value
                    else
                        return ''
                },
                fontSize: 12,
                rich: {
                    name: {}
                }
            };
            // #endregion
            this.divLoading=true;
            var allData
            const{data:res}=await this.$http.post('os/completeStat',{data:this.checkedClass}).catch(err => err)
            if(res){
                allData=res
            }else{
                this.divLoading=false
                return;
            }
            this.divLoading=false
            // 初始化echarts实例
            if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
                this.myChart.dispose();//销毁
            }
            this.myChart = this.$echarts.init(document.getElementById("completeDiv"))
            var wzOption = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter:function(params){
						return "<strong>年份："+params[0].name+"</strong>"  +
                        "<br><span style='color:"+params[0].color+"'><i class='el-icon-s-help'></i></span>  总体已完成： "+ params[0].data+
                        "<br><span style='color:"+params[1].color+"'><i class='el-icon-s-help'></i></span> 总体未完成："+params[1].data+
                        "<br><span style='color:gray'><i class='el-icon-s-help'></i></span> 总体完成率："+params[6].data.label+
                        "<hr/>"+
                        "<br><span style='color:"+params[2].color+"'><i class='el-icon-s-help'></i></span> 声像已完成："+params[2].data+
                        "<br><span style='color:"+params[3].color+"'><i class='el-icon-s-help'></i></span> 声像未完成："+params[3].data+
                        "<br><span style='color:gray'><i class='el-icon-s-help'></i></span> 声像完成率："+params[7].data.label+
                        "<hr/>"+
                        "<br><span style='color:"+params[4].color+"'><i class='el-icon-s-help'></i></span> 纸电已完成："+params[4].data+
                        "<br><span style='color:"+params[5].color+"'><i class='el-icon-s-help'></i></span> 声像未完成："+params[5].data+
                        "<br><span style='color:gray'><i class='el-icon-s-help'></i></span> 纸电完成率："+params[8].data.label
					}
                },
                legend: {
                    data: ['总体已完成', '总体未完成', '声像已完成', '声像未完成', '纸电已完成', '纸电未完成']
                },
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ['line', 'bar', 'stack'] },
                        restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: { show: false },
                        //年份数据
                        data: allData.years
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '总体已完成',
                        type: 'bar',
                        stack: 'all',
                        barGap: '0%',
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            normal: {
                                color:'#5470c6'
                            },
                        },
                        //总体已完成数据
                        data: allData.allComplete
                    },
                    {
                        name: '总体未完成',
                        type: 'bar',
                        stack: 'all',
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            normal: {
                                color: '#219eff'
                            },
                        },
                        //总体未完成数据
                        data: allData.allUnComplete
                    },
                    {
                        name: '声像已完成',
                        type: 'bar',
                        stack: 'sh',
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            normal: {
                                color: '#91cc75'
                            },
                        },
                        //声像已完成数据
                        data: allData.shComplete
                    },
                    {
                        name: '声像未完成',
                        type: 'bar',
                        stack: 'sh',
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            normal: {
                                color: '#a7ffa7'
                            },
                        },
                        //声像未完成数据
                        data: allData.shUnComplete
                    },
                    {
                        name: '纸电已完成',
                        type: 'bar',
                        stack: 'zh',
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            normal: {
                                color: '#f9a22d'
                            },
                        },
                        //纸电已完成数据
                        data: allData.zhComplete
                    },
                    {
                        name: '纸电未完成',
                        type: 'bar',
                        stack: 'zh',
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        itemStyle: {
                            normal: {
                                color: '#fcce8e'
                            },
                        },
                        //纸电未完成数据
                        data: allData.zhUnComplete
                    },


                    {
                        name: '总完成率',
                        type: 'bar',
                        stack: 'all',
                        label: {
                            show: true,
                            position: 'top',
                            color: 'red',
                            formatter: function (params) {
                                return params.data.label
                            }
                        },

                        data: [{value:0,label:allData.allRate[0]}, {value:0,label:allData.allRate[1]}, {value:0,label:allData.allRate[2]}, {value:0,label:allData.allRate[3]}, {value:0,label:allData.allRate[4]}]    //思路一：给series集合末尾多加一栏用于展示合计，但是值都是0；缺点：必须根据xAxis的data生成一组为空的数据，且tooltip不能加trigger: 'axis',这个条件，不然会展示合计：0
                    },
                    {
                        name: '声像完成率',
                        type: 'bar',
                        stack: 'sh',
                        label: {
                            show: true,
                            position: 'top',
                            color: 'red',
                            formatter: function (params) {
                                return params.data.label
                            }
                        },

                        data:[{value:0,label:allData.shRate[0]}, {value:0,label:allData.shRate[1]}, {value:0,label:allData.shRate[2]}, {value:0,label:allData.shRate[3]}, {value:0,label:allData.shRate[4]}]    //思路一：给series集合末尾多加一栏用于展示合计，但是值都是0；缺点：必须根据xAxis的data生成一组为空的数据，且tooltip不能加trigger: 'axis',这个条件，不然会展示合计：0
                    },
                    {
                        name: '纸电完成率',
                        type: 'bar',
                        stack: 'zh',
                        label: {
                            show: true,
                            position: 'top',
                            color: 'red',
                            formatter: function (params) {
                                return params.data.label
                            }
                        },
                        data:[{value:0,label:allData.zhRate[0]}, {value:0,label:allData.zhRate[1]}, {value:0,label:allData.zhRate[2]}, {value:0,label:allData.zhRate[3]}, {value:0,label:allData.zhRate[4]}]    //思路一：给series集合末尾多加一栏用于展示合计，但是值都是0；缺点：必须根据xAxis的data生成一组为空的数据，且tooltip不能加trigger: 'axis',这个条件，不然会展示合计：0
                    }

                ]
            };
            wzOption && this.myChart.setOption(wzOption);
        }
    },
}
</script>
<style scope>
.completeDiv{
    width: 1200px;
    height: 600px;
    overflow: hidden;
}
</style>